enum RoboticMowerSetting {
  SCHEDULE = 'SCHEDULE',
  CUTTING_HEIGHT = 'CUTTING_HEIGHT',
  PATTERN = 'PATTERN',
  MISSION_STATUS = 'MISSION_STATUS',
}

export default RoboticMowerSetting;
